import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AnalyticsTypeMap,
  DATE_VIEW,
  FIXTURES_VIEW,
  MARKETS_VIEW,
  ODDS_VIEW,
} from "../../../../constants";
import styles from "./TabbedFilters.module.scss";
import FilterFixtures from "../../../../layouts/Filter/components/FilterFixtures";
import FilterMarkets from "../../../../layouts/Filter/components/FilterMarkets";
import FilterDate from "../../../../layouts/Filter/components/FilterDate";
import FilterOdds from "../../components/FilterOdds";
import { FILTERS, OPEN } from "../../../../constants/analytics";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";

const TAB_LIST = [
  { label: ODDS_VIEW },
  { label: DATE_VIEW },
  { label: FIXTURES_VIEW },
  { label: MARKETS_VIEW },
];

export function TabbedFilters() {
  const [activeTab, setActiveTab] = useState(TAB_LIST[0].label);
  const { ppConfig } = useSelector((state) => state.filter);
  const { marketGroups } = ppConfig;

  const renderTabContent = () => {
    switch (activeTab) {
      case ODDS_VIEW:
        return <FilterOdds />;
      case DATE_VIEW:
        return <FilterDate />;
      case FIXTURES_VIEW:
        return <FilterFixtures />;
      case MARKETS_VIEW:
        return <FilterMarkets marketGroups={marketGroups} />;
      default:
        return null;
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sendAnalyticsEvent({
      event: FILTERS,
      type: AnalyticsTypeMap.get(tab),
      action: OPEN,
    });
  };

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.tabContainer}>
        {TAB_LIST.map((tab) => (
          <button
            key={tab.label}
            onClick={() => handleTabClick(tab.label)}
            className={`${styles.tab} ${
              activeTab === tab.label ? styles.active : ""
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
}
